/**
 * Libelle de manche.
 *
 * En battle royale, la partie dure ce qu'il faut pour qu'il ne reste qu'un
 * joueur : afficher « manche 2/5 » y serait un mensonge, le total est donc
 * omis. Partout ailleurs le reglage fait foi.
 */
import { hasFixedRounds, totalRounds, type RoomSnapshot } from '@retusch/shared';
import type { Translate } from '../locales/useT.js';

export function roundLabel(t: Translate, room: RoomSnapshot, round: number): string {
  return hasFixedRounds(room.settings.mode)
    ? t('game.round', {
        n: round,
        // Le total est le nombre de manches REELLES : en « un seul dessine »,
        // le reglage compte des tours, pas des manches.
        total: totalRounds(room.settings.mode, room.settings.rounds, room.players.length),
      })
    : t('game.roundOpen', { n: round });
}
